import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';

import App		from 	'./vortex/App'
import AppProject		from 	'./vortex/AppProject'
import AppQuote from './vortex/AppQuote';

ReactDOM.render(<AppQuote />, document.getElementById('root'));
